import script from "./phoneInput.vue?vue&type=script&setup=true&lang=ts"
export * from "./phoneInput.vue?vue&type=script&setup=true&lang=ts"

import "./phoneInput.vue?vue&type=style&index=0&id=7a0d0916&scoped=true&lang=scss"

import exportComponent from "/home/ubuntu/bookonline/ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a0d0916"]])

export default __exports__